import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../../base/store/selectors';
import { betslipPicksListCountSelector, betslipPicksListSelector } from '../../picks/selectors';
import { betslipTypeStateSelector } from '../../types/selectors';
import { AffiliateBetslip } from '../affiliate.model';

export const affiliateStateSelector = createSelector(betslipSelector, (state) => state.affiliateState);
export const affiliateLinkStateSelector = createSelector(affiliateStateSelector, (state) => state.affiliateLink);

export const betslipAffiliateSelector = createSelector(
    betslipTypeStateSelector,
    betslipPicksListSelector,
    betslipPicksListCountSelector,
    (type, picks, picksCount): AffiliateBetslip => ({
        typeState: type,
        picks,
        picksCount,
    }),
);

export const selectAffiliateOptionRequest = createSelector(affiliateStateSelector, (state) => state.optionRequest);
